import { lazyWithPreload } from 'react-lazy-with-preload';

const OnBoardingLayout = lazyWithPreload(() => import('./layouts/onboarding/OnBoardingLayout'));

const CreateUserPage = lazyWithPreload(() => import('./pages/create-user/Page'));
const HomePage = lazyWithPreload(() => import('./pages/home/Page'));

const Routes = [
    {
        path: '/invitations/:invitationId',
        element: <OnBoardingLayout />,
        children: [
            {
                path: '',
                element: <HomePage />,
            },
            {
                path: 'form',
                element: <CreateUserPage />,
            },
        ],
    },
];

export default Routes;
